<div class="d-flex p-5">
  <div class="avs-user-settings shadow">
    <div class="position-relative">
      <input placeholder="Suche" style="top: 24px; left: 135px;" class="position-absolute form-control rounded-0 "
        #search type="text" (keyup)="filterResults(search.value)">
      <table class="table">
        <thead>
          <tr>
            <th class="bg-light ps-4" scope="col" style="min-width: 335px;">Name</th>
            <th class="bg-light ps-4" scope="col">Status</th>
            <th class="bg-light ps-4" scope="col">Rolle</th>
            <th class="bg-light ps-4" scope="col" colspan="2">Institution</th>
            <th class="bg-light ps-4" scope="col" colspan="2">Projekte</th>
            <th class="bg-light text-end" scope="col">
              <button type="button" class="btn ms-0 avs-user-button rounded-0 border-0 shadow"
                (click)="onAddBtnClicked()">
                <span class="text-white text-nowrap">Benutzer hinzufügen</span>
              </button>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let user of filteredUserData; let i = index">
            <td class="ps-1 ps-md-2 ps-xl-4" scope="row">
              <div class="d-flex align-items-center">
                <div>
                  <img class="avs-user" src="../../../assets/icons/person-circle.svg" alt="account circle">
                </div>
                <div>
                  {{ user.title }} {{ user.firstName }} {{ user.lastName }}
                  <div class="avs-user-attributes">{{ user.email }}</div>
                </div>
              </div>
            </td>
            <td >
              <div>
                <ng-container *ngIf="user.isVerified; else notVerified">
                  <span class="avs-state-success p-4">Verifiziert</span>
                </ng-container>
                <ng-template #notVerified>
                  <span class="avs-state-danger p-4">Nicht Verifiziert</span>
                </ng-template>

              </div>
            </td>
            <td class="p-4">{{ getRoleTypesString(user.role) }}</td>
            <td class="p-4" colspan="2">{{ getCompanyName(user.company) }}</td>
            <td class="p-4" colspan="2">
              <ul *ngIf="user.userProjects?.length! > 0">
                <div *ngFor="let project of user.userProjects">
                  <li> {{ getProjectName(project.projectId!) }}</li>
                
                </div>
              </ul>
            </td>
            <td class="pe-0 pe-lg-2">
              <div class="d-flex justify-content-end">
                <div style="width: 74px;">
                  <img class="avs-icon-delete p-2" src="assets/icons/trash.svg" alt="icon-delete-group"
                    (click)="onDeleteBtnClicked(user.id)">
                  <img class="avs-icon-edit p-2" src="assets/icons/pencil.svg" alt="avs-icon-edit"
                    (click)="onEditBtnClicked(user.id)">
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>